<template>
  <div class="pc-note__tools">
    <div class="left">
      <div v-show="sidebarVisible" class="pc-icon" title="隐藏侧边栏" @click="onHideSidebarClick"><i class="el-icon-arrow-left"/></div>
      <div v-show="!sidebarVisible" class="pc-icon" title="显示侧边栏" @click="onShowSidebarClick"><i class="el-icon-arrow-right"/></div>
      <div class="status" v-if="isNoteContentChanged">
        <template v-if="!saveNoteContentInProcess">
        <span class="dot"></span><span>未保存 (ctrl+s保存)</span>
        </template>
        <span v-else>保存中...</span>
      </div>
    </div>
    <div class="middle"></div>
    <div class="right">
      <icon-ellipsis-h title="更多操作..."/>
      <icon-arrow-circle-up title="回到顶部" @click="goTopHandler"/>
      <icon-compress v-show="presentationMode" title="退出演示模式" @click="onExitPresentationModeClick"/>
      <icon-presentation v-show="!presentationMode" title="打开演示模式" @click="onOpenPresentationModeClick"/>
      <icon-eye v-show="!preview" title="切换到预览模式" @click="previewHandler"/>
      <icon-pen v-show="preview" title="切换到编辑模式" @click="editHandler"/>
      <icon-image-polaroid v-show="!preview" title="插入图片" @click="showInsertImageDailogHandler"/>
    </div>
  </div>
</template>

<script>
import IconEye from '@/components/icon/Eye.vue'
import IconPen from '@/components/icon/Pen.vue'
import IconPresentation from '@/components/icon/Presentation.vue'
import IconEllipsisH from '@/components/icon/EllipsisH.vue'
import IconArrowCircleUp from '@/components/icon/ArrowCircleUp.vue'
import IconCompress from '@/components/icon/Compress.vue'
import IconImagePolaroid from '@/components/icon/ImagePolaroid.vue'
import { mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    IconEye,
    IconPen,
    IconPresentation,
    IconEllipsisH,
    IconArrowCircleUp,
    IconCompress,
    IconImagePolaroid
  },
  mounted () {
    // https://stackoverflow.com/questions/25126106/capture-esc-event-when-exiting-full-screen-mode
    window.document.addEventListener('fullscreenchange', this.fullscreenChangeHandler)
    window.addEventListener('webkitfullscreenchange', this.fullscreenChangeHandler)
  },
  beforeDestroy () {
    window.document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler)
    window.removeEventListener('webkitfullscreenchange', this.fullscreenChangeHandler)
  },
  computed: {
    ...mapGetters({
      sidebarVisible: 'workbench/sidebarVisible',
      fullscreen: 'workbench/fullscreen',
      preview: 'workbench/current/preview',
      presentationMode: 'workbench/presentationMode',
      isNoteContentChanged: 'workbench/current/isNoteContentChanged',
      saveNoteContentInProcess: 'workbench/current/saveNoteContentInProcess'
    })
  },
  methods: {
    ...mapMutations({
      setPreview: 'workbench/current/SET_PREVIEW',
      setSidebarVisible: 'workbench/SET_SIDEBAR_VISIBLE',
      setPresentationMode: 'workbench/SET_PRESENTATION_MODE',
      setInsertImage: 'dialog/SET_INSERT_IMAGE'
    }),
    previewHandler () {
      this.setPreview(true)
    },
    editHandler () {
      this.setPreview(false)
    },
    goTopHandler () {
      window.document.getElementById('pc-page__note').scrollTo(0, 0)
    },
    onHideSidebarClick () {
      this.setSidebarVisible(false)
    },
    onShowSidebarClick () {
      this.setSidebarVisible(true)
    },
    fullscreenChangeHandler () {
      if (!window.document.fullscreenElement) {
        this.setPresentationMode(false)
        this.setSidebarVisible(true)
      }
    },
    onExitPresentationModeClick () {
      window.document.exitFullscreen()
      this.setPresentationMode(false)
      this.setSidebarVisible(true)
    },
    onOpenPresentationModeClick () {
      window.document.body.requestFullscreen()
      this.setPresentationMode(true)
      this.setSidebarVisible(false)
    },
    showInsertImageDailogHandler () {
      this.setInsertImage({
        visible: true
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__tools {
  border-top: 1px solid transparent; // 不加这个预览编辑按钮点击会导致抖动
  height: 3rem;
  min-height: 3rem;
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 2000;
  display: flex;
  flex-direction: row;
  padding: 0 .5rem;
  color: $color-b3;
  cursor: default;
  user-select: none;

  .pc-icon {
    width: 2.4rem;
    height: 2.4rem;
    font-size: 1.2rem;
    margin-right: .5rem;
  }

  // .pc-icon + .pc-icon {
  //   margin-left: .5rem;
  // }

  .left,.right,.middle {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .middle {
    width: 0;
    flex-grow: 1;
  }

  .right {
    flex-direction: row-reverse;

    .pc-icon:first-of-type {
      margin-right: 0;
    }
  }

  .status {
    display: flex;
    align-items: center;
    color: $color-danger;
    // margin-left: 1rem;

    span:last-of-type {
      margin-left: .5rem;
    }

    .dot {
      width: .6rem;
      height: .6rem;
      border-radius: 50%;
      background: $color-danger;
    }
  }

  code {
    // border: 1px solid $border-color-structure;
    // padding: 0 .5rem;
  }
}
</style>
